/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_MultidayInputs */



/**
* | output |
* | --- |
* | "How do I handle a multi-day tournament?" |
*
* @param {Og_Faq_Q_MultidayInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_multiday = /** @type {((inputs?: Og_Faq_Q_MultidayInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_MultidayInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment gérer un tournoi multi-jours ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cómo gestiono un torneo de varios días?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Como lidar com um torneio de múltiplos dias?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come gestisco un torneo multigiorno?")
	return /** @type {LocalizedString} */ ("How do I handle a multi-day tournament?")
});